import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TransitionLoader from './common/TransitionLoader';

const InstructorRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // 1. Wait for Auth & Role to load (Prevents premature kick-out)
  if (loading) {
    return <TransitionLoader />;
  }

  // 2. If not logged in, go to Login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 3. Check Role: Allow 'instructor' OR 'admin'
  // (Admins should have super-access)
  if (user.role !== 'instructor' && user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default InstructorRoute;